import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";

const sizeMap = {
  small: { box: 32, icon: 16 },
  medium: { box: 40, icon: 20 },
  large: { box: 48, icon: 24 },
};

/**
 * Shared V2 action chrome — colors from global brand CSS variables.
 */
export default function ActionIconButton({
  title,
  onClick,
  disabled = false,
  size = "medium",
  children,
  className = "v2-action-btn",
  sx = null,
  "aria-label": ariaLabel,
}) {
  const dims = sizeMap[size] || sizeMap.medium;

  const button = (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      aria-label={ariaLabel || title}
      sx={{
        bgcolor: "var(--brand-surface)",
        width: dims.box,
        height: dims.box,
        borderRadius: "var(--brand-radius-md)",
        border: "1px solid var(--brand-line)",
        boxShadow: "none",
        color: "var(--brand-accent)",
        "&:hover": {
          bgcolor: "var(--brand-accent-soft)",
          borderColor: "var(--brand-accent-border)",
          boxShadow: "none",
        },
        ...sx,
      }}
    >
      {typeof children === "function" ? children(dims.icon) : children}
    </IconButton>
  );

  if (!title) return button;

  return (
    <Tooltip title={title}>
      <span style={{ display: "inline-flex" }}>{button}</span>
    </Tooltip>
  );
}

ActionIconButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  sx: PropTypes.object,
  "aria-label": PropTypes.string,
};

export { sizeMap as ACTION_ICON_SIZES };
